import { Icon, IconBase64 } from '@synergy/icons';
import { Col, Divider, Row, Skeleton } from "antd";
import isEqual from "lodash/isEqual";
import { useEffect, useMemo, useRef, useState } from 'react';
import styled from "styled-components";
import Theme from "../../styles/Theme/Theme";
import { REACT_APP_COMMAND_INCIDENT_URL } from '../../utils/config/configs';
import { groupBy } from "../../utils/hooks/gourpBy";
import { isEmpty } from "../../utils/hooks/isEmpty";
import Button from "../Global/Atomics/Button";
import Container from "../Global/Atomics/Container";
const ServiceGroup = styled.div`
    display: flex;
    justify-content: space-between;
    margin-bottom: 10px;

    > span {
        display: flex;
        align-items: center;
        color: ${Theme.color['blue-4']};
        cursor: pointer;

        &:hover {
            transition: all 0.3s ease-in-out;
            transform: scale(1.05);
        }
    }
`;

const ServiceNameText = styled.div`
    /* margin-bottom: 10px; */
    font-weight: bold;
    align-content: center;
`;

const ViewDetailsSpan = styled.span`
    display: flex;
    align-items: center;
    gap: 5;
    color: #0076A8;
    margin: 0;
    cursor: pointer;

    &:hover {
        transition: all 0.3s ease-in-out;
        transform: scale(1.05);
    }
`;
const useDeepMemo = (factory, dependencies) => {
    const previousDeps = useRef();
    const memoizedValue = useRef();

    if (!isEqual(previousDeps.current, dependencies)) {
        previousDeps.current = dependencies;
        memoizedValue.current = factory();
    }

    return memoizedValue.current;
};



export const RegisterDetailClusterView = ({ selectedCluster, setSelectedPOI, selectedLayer, addNewIncidentToMap, isDrawerOpen }) => {


    if (!selectedCluster || isEmpty(selectedCluster) || !isDrawerOpen) {
        return null;
    };

    // const { t } = useTranslation();

    // ------------------ Code commented out for future use ------------------
    // const [createIncidentModal, setCreateIncidentModal] = useState(false);
    // const [coordinatesToCreateIncident, setCoordinatesToCreateIncident] = useState(null);


    // const createIncident = (service) => {
    //     if (!service) return;

    //     setCreateIncidentModal(true);
    //     const lat = service.latitude;
    //     const lng = service.longitude;
    //     setCoordinatesToCreateIncident({ lat, lng });
    // };
    // Garante uma string estável baseada no valor de selectedCluster
    const stableSelectedClusterStr = useMemo(() => JSON.stringify(selectedCluster), [selectedCluster]);

    // Agora o useDeepMemo receberá uma dependência "estável" e só recalculará se o valor de selectedCluster mudar realmente
    const groupedCluster = useDeepMemo(() => {
        if (!selectedCluster || isEmpty(selectedCluster)) return [];
        console.log("selectedCluster", selectedCluster);
        return Object.entries(selectedCluster).map(([key, value]) => ({
            key,
            grouped: groupBy(value, "serviceName"),
        }));
    }, [stableSelectedClusterStr]);

    useEffect(() => {
        console.log("Componente montado");

        return () => {
            console.log("Componente desmontado");
        };
    }, []);

    return (
        <>
            {/* {Object.entries(selectedCluster).map(([key, value], index) => {
                const groupbyServiceName = groupBy(value, 'serviceName');

                if (!groupbyServiceName || isEmpty(groupbyServiceName)) {
                    return null;
                } */}

            {/* return ( */}
            {/* <div key={index}> */}

            {groupedCluster?.[0]?.grouped && Object.entries(groupedCluster[0].grouped).map(([serviceName, services], subIndex) => (
                <div key={subIndex}>
                    {selectedLayer === 'Incidents' ?
                        <ServiceGroup>
                            <ServiceNameText>{serviceName.toUpperCase()}</ServiceNameText>
                            {/* <span onClick={() => createIncident(services?.[0])}>{t('button.create_incident')} <Icon icon='Plus' color={Theme.color['blue-4']} iconsize="xs" /></span> */}
                        </ServiceGroup>
                        : null}
                    {services.map((item, index) => (
                        <LazyCard key={index}>
                            <Container fontSize='1rem' justifyItem='flex-start' alignItem='flex-start'
                                titlePadding='0px' key={index} width='100%' wrapperMinHeight='auto' cardMarginBottom='20px'>
                                {selectedLayer === 'Incidents' ?
                                    <Row gutter={[16, 16]} style={{ width: '100%' }}>
                                        <Col span={4} style={{ display: 'flex', alignItems: 'center' }}>
                                            <img src={IconBase64({ label: 'Incident', priority: item.priority, family: item.family, class: item.class })}
                                                width='35px' />
                                        </Col>
                                        <Col span={8}>
                                            <PropertiesBox title='Incident number' value={item.name} />
                                        </Col>
                                        <Col span={12} style={{ display: 'flex', justifyContent: 'flex-end' }}>
                                            <Button size='xxs' $backgroundColor={Theme.color['blue-4']}
                                                onClick={() => window.open(`${REACT_APP_COMMAND_INCIDENT_URL}${item.id}`, '_blank')}
                                            >Manage Incident <Icon icon='External' color="white" iconsize="xs" /></Button>
                                        </Col>

                                        <Divider style={{ margin: '0', borderTop: '1px solid #ccc' }} />

                                        <Col span={24}>
                                            <Row gutter={[16, 16]}>
                                                <Col span={8}>
                                                    <PropertiesBox title='Last update' value={item.lastUpdate ? convertDate(item.lastUpdate) : 'N/A'} />
                                                </Col>
                                                <Col span={8}>
                                                    <PropertiesBox title='Status' value={item.status} />
                                                </Col>
                                                <Col span={8} style={{ display: 'flex', justifyContent: 'flex-end' }}>
                                                    <ViewDetailsSpan onClick={() => setSelectedPOI(item)}>View Details<Icon iconsize={'xs'} icon="ArrowRight" color={'#0076A8'} /></ViewDetailsSpan>
                                                </Col>
                                            </Row>
                                        </Col>
                                    </Row>
                                    :
                                    <Row gutter={[16, 16]} style={{ width: '100%' }}>
                                        <Col span={4} style={{ display: 'flex', alignItems: 'center' }}>
                                            <img src={IconBase64({ label: item.label, priority: item.priority, family: item.family, class: item.class })}
                                                width='35px' />
                                        </Col>
                                        <Col span={8}>
                                            <PropertiesBox title='Service Name' value={item.name} />
                                        </Col>
                                        <Col span={12} style={{ display: 'flex', justifyContent: 'flex-end' }}>
                                            <ViewDetailsSpan onClick={() => setSelectedPOI(item)}>View Details<Icon iconsize={'xs'} icon="ArrowRight" color={'#0076A8'} /></ViewDetailsSpan>
                                        </Col>
                                    </Row>
                                }
                            </Container>
                        </LazyCard>
                    ))}

                    {selectedLayer === 'Incidents' ? <Divider style={{ border: '1px solid gray' }} /> : null}
                </div>
            ))}
            {/* </div> */}
            {/* ); */}
            {/* })} */}

            {/* <MapCreateIncidentModal isCreateIncidentModalOpen={createIncidentModal} setCreateIncidentModal={setCreateIncidentModal}
                mapClickCoordinates={coordinatesToCreateIncident} addNewIncidentToMap={addNewIncidentToMap} /> */}
        </>
    )
};

export const PropertiesBox = ({ title, value }) => {
    return (
        <>
            <div style={{ color: '#63666A' }}>{title}</div>
            <div>{value}</div>
        </>
    )
};

const convertDate = (timestamp) => {
    const date = new Date(timestamp * 1000);
    return date.toLocaleDateString() + ' ' + date.toLocaleTimeString().slice(0, -3);
};

const LazyCard = ({ children }) => {

    const [isVisible, setIsVisible] = useState(false);
    const ref = useRef(null);

    useEffect(() => {
        const observer = new IntersectionObserver(
            (entries) => {
                const entry = entries[0];
                if (entry.isIntersecting) {
                    setIsVisible(true);
                    observer.disconnect(); // para de observar após o elemento estar visível
                }
            },
            { threshold: 0.1 }
        );

        if (ref.current) {
            observer.observe(ref.current);
        }

        return () => {
            observer.disconnect();
        }
    }, []);

    return (
        <div ref={ref}>
            {isVisible ? (
                children
            ) : (
                <Skeleton />
            )}
        </div>
    );
};